import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ShoppingBag, Menu, X } from "lucide-react";
import { useCart } from "../context/CartContext";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/shop", label: "Shop" },
  { to: "/shop/borse", label: "Borse" },
  { to: "/shop/accessori", label: "Accessori" },
  { to: "/shop/abbigliamento", label: "Abbigliamento" },
  { to: "/su-misura", label: "Su Misura" },
  { to: "/about", label: "Storia" },
  { to: "/contact", label: "Contatti" },
];

export default function Navbar() {
  const { count, setOpen } = useCart();
  const [mobile, setMobile] = React.useState(false);
  const location = useLocation();

  React.useEffect(() => { setMobile(false); }, [location.pathname]);

  return (
    <header
      data-testid="navbar"
      className="sticky top-0 z-40 bg-alimi-bg/85 backdrop-blur-md border-b border-alimi-border"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Mobile menu btn */}
          <button
            data-testid="mobile-menu-btn"
            className="lg:hidden text-alimi-ink"
            onClick={() => setMobile(!mobile)}
            aria-label="Menu"
          >
            {mobile ? <X size={22} /> : <Menu size={22} />}
          </button>

          {/* Logo */}
          <Link to="/" data-testid="brand-logo" className="flex flex-col items-center mx-auto lg:mx-0">
            <span className="font-serif text-3xl tracking-[0.18em] text-alimi-ink leading-none">
              ALIMÌ
            </span>
            <span className="text-[0.55rem] tracking-[0.35em] uppercase text-alimi-gold mt-1">
              Creazioni che raccontano
            </span>
          </Link>

          {/* Desktop nav */}
          <nav className="hidden lg:flex items-center gap-9 text-[0.78rem] tracking-[0.18em] uppercase text-alimi-ink">
            {NAV.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                data-testid={`nav-${n.label.toLowerCase()}`}
                className="link-underline"
              >
                {n.label}
              </Link>
            ))}
          </nav>

          {/* Cart */}
          <button
            data-testid="cart-button"
            onClick={() => setOpen(true)}
            className="relative text-alimi-ink hover:text-alimi-gold transition-colors"
            aria-label="Apri carrello"
          >
            <ShoppingBag size={22} strokeWidth={1.4} />
            {count > 0 && (
              <span
                data-testid="cart-count"
                className="absolute -top-1.5 -right-2 bg-alimi-gold text-white text-[10px] font-medium rounded-full w-4 h-4 flex items-center justify-center"
              >
                {count}
              </span>
            )}
          </button>
        </div>

        {/* Mobile menu */}
        {mobile && (
          <nav className="lg:hidden pb-6 flex flex-col gap-4 text-sm tracking-[0.18em] uppercase">
            {NAV.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                data-testid={`mnav-${n.label.toLowerCase()}`}
                className="text-alimi-ink"
              >
                {n.label}
              </Link>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
}
